!function (e, t) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = t(require("react"), require("react-dom"));else if ("function" == typeof define && define.amd) define(["react", "react-dom"], t);else {
    var n = "object" == typeof exports ? t(require("react"), require("react-dom")) : t(e.React, e.ReactDOM);
    for (var r in n) ("object" == typeof exports ? exports : e)[r] = n[r];
  }
}("undefined" != typeof self ? self : this, function (e, t) {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 3);
  }([function (e, t) {
    function n() {
      throw new Error("setTimeout has not been defined");
    }
    function r() {
      throw new Error("clearTimeout has not been defined");
    }
    function o(e) {
      if (f === setTimeout) return setTimeout(e, 0);
      if ((f === n || !f) && setTimeout) return f = setTimeout, setTimeout(e, 0);
      try {
        return f(e, 0);
      } catch (t) {
        try {
          return f.call(null, e, 0);
        } catch (t) {
          return f.call(this, e, 0);
        }
      }
    }
    function i(e) {
      if (l === clearTimeout) return clearTimeout(e);
      if ((l === r || !l) && clearTimeout) return l = clearTimeout, clearTimeout(e);
      try {
        return l(e);
      } catch (t) {
        try {
          return l.call(null, e);
        } catch (t) {
          return l.call(this, e);
        }
      }
    }
    function a() {
      m && d && (m = !1, d.length ? y = d.concat(y) : h = -1, y.length && u());
    }
    function u() {
      if (!m) {
        var e = o(a);
        m = !0;
        for (var t = y.length; t;) {
          for (d = y, y = []; ++h < t;) d && d[h].run();
          h = -1, t = y.length;
        }
        d = null, m = !1, i(e);
      }
    }
    function c(e, t) {
      this.fun = e, this.array = t;
    }
    function s() {}
    var f,
      l,
      p = e.exports = {};
    !function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : n;
      } catch (e) {
        f = n;
      }
      try {
        l = "function" == typeof clearTimeout ? clearTimeout : r;
      } catch (e) {
        l = r;
      }
    }();
    var d,
      y = [],
      m = !1,
      h = -1;
    p.nextTick = function (e) {
      var t = new Array(arguments.length - 1);
      if (arguments.length > 1) for (var n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
      y.push(new c(e, t)), 1 !== y.length || m || o(u);
    }, c.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = s, p.addListener = s, p.once = s, p.off = s, p.removeListener = s, p.removeAllListeners = s, p.emit = s, p.prependListener = s, p.prependOnceListener = s, p.listeners = function (e) {
      return [];
    }, p.binding = function (e) {
      throw new Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (e) {
      throw new Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (e, t, n) {
    "use strict";

    e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      "production" === t.env.NODE_ENV ? e.exports = n(8) : e.exports = n(9);
    }).call(t, n(0));
  }, function (e, t, n) {
    e.exports = n(4);
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    function o(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function i(e, t) {
      if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !t || "object" != typeof t && "function" != typeof t ? e : t;
    }
    function a(e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var u = function () {
        function e(e, t) {
          for (var n = 0; n < t.length; n++) {
            var r = t[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
          }
        }
        return function (t, n, r) {
          return n && e(t.prototype, n), r && e(t, r), t;
        };
      }(),
      c = n(5),
      s = r(c),
      f = n(6),
      l = r(f),
      p = n(7),
      d = r(p),
      y = {
        toolbar: "no",
        location: "no",
        directories: "no",
        status: "no",
        menubar: "no",
        scrollbars: "yes",
        resizable: "yes",
        width: 500,
        height: 400,
        top: function top(e, t) {
          return (t.innerHeight - e.height) / 2 + t.screenY;
        },
        left: function left(e, t) {
          return (t.innerWidth - e.width) / 2 + t.screenX;
        }
      },
      m = function (e) {
        function t(e) {
          o(this, t);
          var n = i(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));
          return n.mainWindowClosed = n.mainWindowClosed.bind(n), n.popoutWindowUnloading = n.popoutWindowUnloading.bind(n), n.popoutWindowLoaded = n.popoutWindowLoaded.bind(n), n.state = {
            openedWindowComponent: null,
            popoutWindow: null,
            container: null
          }, n;
        }
        return a(t, e), u(t, [{
          key: "createOptions",
          value: function value(e) {
            var t = this,
              n = Object.assign({}, y, this.props.options);
            return Object.keys(n).map(function (r) {
              return r + "=" + ("function" == typeof n[r] ? n[r].call(t, n, e) : n[r]);
            }).join(",");
          }
        }, {
          key: "componentDidMount",
          value: function value() {
            var e = this.props.window || window;
            e && (this.openPopoutWindow(e), e.addEventListener("unload", this.mainWindowClosed));
          }
        }, {
          key: "componentWillReceiveProps",
          value: function value(e) {
            e.title !== this.props.title && this.state.popoutWindow && (this.state.popoutWindow.document.title = e.title);
          }
        }, {
          key: "componentDidUpdate",
          value: function value() {
            this.renderToContainer(this.state.container, this.state.popoutWindow, this.props.children);
          }
        }, {
          key: "componentWillUnmount",
          value: function value() {
            this.mainWindowClosed();
          }
        }, {
          key: "popoutWindowLoaded",
          value: function value(e) {
            if (!this.state.container) {
              e = this.state.popoutWindow || e, e.document.title = this.props.title;
              var t = e.document.createElement("div");
              t.id = this.props.containerId, e.document.body.appendChild(t), this.setState({
                container: t
              }), this.renderToContainer(t, e, this.props.children);
            }
          }
        }, {
          key: "openPopoutWindow",
          value: function value(e) {
            var t = e.open(this.props.url, this.props.name || this.props.title, this.createOptions(e));
            if (!t) return void this.props.onError();
            this.setState({
              popoutWindow: t
            }), t.addEventListener("load", this.popoutWindowLoaded), t.addEventListener("beforeunload", this.popoutWindowUnloading), "about:blank" === this.props.url && "complete" === t.document.readyState && this.popoutWindowLoaded(t);
          }
        }, {
          key: "closeWindow",
          value: function value() {
            this.mainWindowClosed();
          }
        }, {
          key: "mainWindowClosed",
          value: function value() {
            this.state.popoutWindow && this.state.popoutWindow.close(), (this.props.window || window).removeEventListener("unload", this.mainWindowClosed);
          }
        }, {
          key: "popoutWindowUnloading",
          value: function value() {
            l.default.unmountComponentAtNode(this.state.container), this.props.onClosing && this.props.onClosing();
          }
        }, {
          key: "renderToContainer",
          value: function value(e, t, n) {
            if (e) {
              var r = n;
              "function" == typeof n && (r = n(t)), l.default.render(r, e);
            }
          }
        }, {
          key: "render",
          value: function value() {
            return null;
          }
        }]), t;
      }(s.default.Component);
    m.defaultProps = {
      url: "about:blank",
      containerId: "popout-content-container",
      onError: function onError() {}
    }, m.propTypes = {
      title: d.default.string.isRequired,
      url: d.default.string,
      onClosing: d.default.func,
      options: d.default.object,
      window: d.default.object,
      containerId: d.default.string,
      children: d.default.oneOfType([d.default.element, d.default.func]),
      onError: d.default.func
    }, t.default = m;
  }, function (t, n) {
    t.exports = e;
  }, function (e, n) {
    e.exports = t;
  }, function (e, t, n) {
    (function (t) {
      if ("production" !== t.env.NODE_ENV) {
        var r = n(2);
        e.exports = n(10)(r.isElement, !0);
      } else e.exports = n(13)();
    }).call(t, n(0));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;
        switch (t) {
          case a:
            switch (e = e.type) {
              case d:
              case y:
              case c:
              case f:
              case s:
              case h:
                return e;
              default:
                switch (e = e && e.$$typeof) {
                  case p:
                  case m:
                  case l:
                    return e;
                  default:
                    return t;
                }
            }
          case b:
          case v:
          case u:
            return t;
        }
      }
    }
    function o(e) {
      return r(e) === y;
    } /** @license React v16.8.4
      * react-is.production.min.js
      *
      * Copyright (c) Facebook, Inc. and its affiliates.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      */
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = "function" == typeof Symbol && Symbol.for,
      a = i ? Symbol.for("react.element") : 60103,
      u = i ? Symbol.for("react.portal") : 60106,
      c = i ? Symbol.for("react.fragment") : 60107,
      s = i ? Symbol.for("react.strict_mode") : 60108,
      f = i ? Symbol.for("react.profiler") : 60114,
      l = i ? Symbol.for("react.provider") : 60109,
      p = i ? Symbol.for("react.context") : 60110,
      d = i ? Symbol.for("react.async_mode") : 60111,
      y = i ? Symbol.for("react.concurrent_mode") : 60111,
      m = i ? Symbol.for("react.forward_ref") : 60112,
      h = i ? Symbol.for("react.suspense") : 60113,
      v = i ? Symbol.for("react.memo") : 60115,
      b = i ? Symbol.for("react.lazy") : 60116;
    t.typeOf = r, t.AsyncMode = d, t.ConcurrentMode = y, t.ContextConsumer = p, t.ContextProvider = l, t.Element = a, t.ForwardRef = m, t.Fragment = c, t.Lazy = b, t.Memo = v, t.Portal = u, t.Profiler = f, t.StrictMode = s, t.Suspense = h, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === c || e === y || e === f || e === s || e === h || "object" == typeof e && null !== e && (e.$$typeof === b || e.$$typeof === v || e.$$typeof === l || e.$$typeof === p || e.$$typeof === m);
    }, t.isAsyncMode = function (e) {
      return o(e) || r(e) === d;
    }, t.isConcurrentMode = o, t.isContextConsumer = function (e) {
      return r(e) === p;
    }, t.isContextProvider = function (e) {
      return r(e) === l;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === a;
    }, t.isForwardRef = function (e) {
      return r(e) === m;
    }, t.isFragment = function (e) {
      return r(e) === c;
    }, t.isLazy = function (e) {
      return r(e) === b;
    }, t.isMemo = function (e) {
      return r(e) === v;
    }, t.isPortal = function (e) {
      return r(e) === u;
    }, t.isProfiler = function (e) {
      return r(e) === f;
    }, t.isStrictMode = function (e) {
      return r(e) === s;
    }, t.isSuspense = function (e) {
      return r(e) === h;
    };
  }, function (e, t, n) {
    "use strict";

    (function (e) {
      /** @license React v16.8.4
      * react-is.development.js
      *
      * Copyright (c) Facebook, Inc. and its affiliates.
      *
      * This source code is licensed under the MIT license found in the
      * LICENSE file in the root directory of this source tree.
      */
      "production" !== e.env.NODE_ENV && function () {
        function e(e) {
          return "string" == typeof e || "function" == typeof e || e === w || e === S || e === O || e === g || e === P || "object" == typeof e && null !== e && (e.$$typeof === C || e.$$typeof === _ || e.$$typeof === E || e.$$typeof === j || e.$$typeof === T);
        }
        function n(e) {
          if ("object" == typeof e && null !== e) {
            var t = e.$$typeof;
            switch (t) {
              case v:
                var n = e.type;
                switch (n) {
                  case x:
                  case S:
                  case w:
                  case O:
                  case g:
                  case P:
                    return n;
                  default:
                    var r = n && n.$$typeof;
                    switch (r) {
                      case j:
                      case T:
                      case E:
                        return r;
                      default:
                        return t;
                    }
                }
              case C:
              case _:
              case b:
                return t;
            }
          }
        }
        function r(e) {
          return J || (J = !0, $(!1, "The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), o(e) || n(e) === x;
        }
        function o(e) {
          return n(e) === S;
        }
        function i(e) {
          return n(e) === j;
        }
        function a(e) {
          return n(e) === E;
        }
        function u(e) {
          return "object" == typeof e && null !== e && e.$$typeof === v;
        }
        function c(e) {
          return n(e) === T;
        }
        function s(e) {
          return n(e) === w;
        }
        function f(e) {
          return n(e) === C;
        }
        function l(e) {
          return n(e) === _;
        }
        function p(e) {
          return n(e) === b;
        }
        function d(e) {
          return n(e) === O;
        }
        function y(e) {
          return n(e) === g;
        }
        function m(e) {
          return n(e) === P;
        }
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var h = "function" == typeof Symbol && Symbol.for,
          v = h ? Symbol.for("react.element") : 60103,
          b = h ? Symbol.for("react.portal") : 60106,
          w = h ? Symbol.for("react.fragment") : 60107,
          g = h ? Symbol.for("react.strict_mode") : 60108,
          O = h ? Symbol.for("react.profiler") : 60114,
          E = h ? Symbol.for("react.provider") : 60109,
          j = h ? Symbol.for("react.context") : 60110,
          x = h ? Symbol.for("react.async_mode") : 60111,
          S = h ? Symbol.for("react.concurrent_mode") : 60111,
          T = h ? Symbol.for("react.forward_ref") : 60112,
          P = h ? Symbol.for("react.suspense") : 60113,
          _ = h ? Symbol.for("react.memo") : 60115,
          C = h ? Symbol.for("react.lazy") : 60116,
          k = function k() {},
          W = function W(e) {
            for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
            var o = 0,
              i = "Warning: " + e.replace(/%s/g, function () {
                return n[o++];
              });
            "undefined" != typeof console && console.warn(i);
            try {
              throw new Error(i);
            } catch (e) {}
          };
        k = function k(e, t) {
          if (void 0 === t) throw new Error("`lowPriorityWarning(condition, format, ...args)` requires a warning message argument");
          if (!e) {
            for (var n = arguments.length, r = Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) r[o - 2] = arguments[o];
            W.apply(void 0, [t].concat(r));
          }
        };
        var $ = k,
          I = x,
          N = S,
          R = j,
          M = E,
          A = v,
          L = T,
          V = w,
          D = C,
          q = _,
          F = b,
          U = O,
          z = g,
          Y = P,
          J = !1;
        t.typeOf = n, t.AsyncMode = I, t.ConcurrentMode = N, t.ContextConsumer = R, t.ContextProvider = M, t.Element = A, t.ForwardRef = L, t.Fragment = V, t.Lazy = D, t.Memo = q, t.Portal = F, t.Profiler = U, t.StrictMode = z, t.Suspense = Y, t.isValidElementType = e, t.isAsyncMode = r, t.isConcurrentMode = o, t.isContextConsumer = i, t.isContextProvider = a, t.isElement = u, t.isForwardRef = c, t.isFragment = s, t.isLazy = f, t.isMemo = l, t.isPortal = p, t.isProfiler = d, t.isStrictMode = y, t.isSuspense = m;
      }();
    }).call(t, n(0));
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function r() {
        return null;
      }
      var o = n(2),
        i = n(11),
        a = n(1),
        u = n(12),
        c = Function.call.bind(Object.prototype.hasOwnProperty),
        s = function s() {};
      "production" !== t.env.NODE_ENV && (s = function s(e) {
        var t = "Warning: " + e;
        "undefined" != typeof console && console.error(t);
        try {
          throw new Error(t);
        } catch (e) {}
      }), e.exports = function (e, n) {
        function f(e) {
          var t = e && (_ && e[_] || e[C]);
          if ("function" == typeof t) return t;
        }
        function l(e, t) {
          return e === t ? 0 !== e || 1 / e == 1 / t : e !== e && t !== t;
        }
        function p(e) {
          this.message = e, this.stack = "";
        }
        function d(e) {
          function r(r, u, c, f, l, d, y) {
            if (f = f || k, d = d || c, y !== a) {
              if (n) {
                var m = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                throw m.name = "Invariant Violation", m;
              }
              if ("production" !== t.env.NODE_ENV && "undefined" != typeof console) {
                var h = f + ":" + c;
                !o[h] && i < 3 && (s("You are manually calling a React.PropTypes validation function for the `" + d + "` prop on `" + f + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), o[h] = !0, i++);
              }
            }
            return null == u[c] ? r ? new p(null === u[c] ? "The " + l + " `" + d + "` is marked as required in `" + f + "`, but its value is `null`." : "The " + l + " `" + d + "` is marked as required in `" + f + "`, but its value is `undefined`.") : null : e(u, c, f, l, d);
          }
          if ("production" !== t.env.NODE_ENV) var o = {},
            i = 0;
          var u = r.bind(null, !1);
          return u.isRequired = r.bind(null, !0), u;
        }
        function y(e) {
          function t(t, n, r, o, i, a) {
            var u = t[n];
            if (x(u) !== e) return new p("Invalid " + o + " `" + i + "` of type `" + S(u) + "` supplied to `" + r + "`, expected `" + e + "`.");
            return null;
          }
          return d(t);
        }
        function m(e) {
          function t(t, n, r, o, i) {
            if ("function" != typeof e) return new p("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
            var u = t[n];
            if (!Array.isArray(u)) {
              return new p("Invalid " + o + " `" + i + "` of type `" + x(u) + "` supplied to `" + r + "`, expected an array.");
            }
            for (var c = 0; c < u.length; c++) {
              var s = e(u, c, r, o, i + "[" + c + "]", a);
              if (s instanceof Error) return s;
            }
            return null;
          }
          return d(t);
        }
        function h(e) {
          function t(t, n, r, o, i) {
            if (!(t[n] instanceof e)) {
              var a = e.name || k;
              return new p("Invalid " + o + " `" + i + "` of type `" + P(t[n]) + "` supplied to `" + r + "`, expected instance of `" + a + "`.");
            }
            return null;
          }
          return d(t);
        }
        function v(e) {
          function n(t, n, r, o, i) {
            for (var a = t[n], u = 0; u < e.length; u++) if (l(a, e[u])) return null;
            var c = JSON.stringify(e, function (e, t) {
              return "symbol" === S(t) ? String(t) : t;
            });
            return new p("Invalid " + o + " `" + i + "` of value `" + String(a) + "` supplied to `" + r + "`, expected one of " + c + ".");
          }
          return Array.isArray(e) ? d(n) : ("production" !== t.env.NODE_ENV && s(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), r);
        }
        function b(e) {
          function t(t, n, r, o, i) {
            if ("function" != typeof e) return new p("Property `" + i + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
            var u = t[n],
              s = x(u);
            if ("object" !== s) return new p("Invalid " + o + " `" + i + "` of type `" + s + "` supplied to `" + r + "`, expected an object.");
            for (var f in u) if (c(u, f)) {
              var l = e(u, f, r, o, i + "." + f, a);
              if (l instanceof Error) return l;
            }
            return null;
          }
          return d(t);
        }
        function w(e) {
          function n(t, n, r, o, i) {
            for (var u = 0; u < e.length; u++) {
              if (null == (0, e[u])(t, n, r, o, i, a)) return null;
            }
            return new p("Invalid " + o + " `" + i + "` supplied to `" + r + "`.");
          }
          if (!Array.isArray(e)) return "production" !== t.env.NODE_ENV && s("Invalid argument supplied to oneOfType, expected an instance of array."), r;
          for (var o = 0; o < e.length; o++) {
            var i = e[o];
            if ("function" != typeof i) return s("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + T(i) + " at index " + o + "."), r;
          }
          return d(n);
        }
        function g(e) {
          function t(t, n, r, o, i) {
            var u = t[n],
              c = x(u);
            if ("object" !== c) return new p("Invalid " + o + " `" + i + "` of type `" + c + "` supplied to `" + r + "`, expected `object`.");
            for (var s in e) {
              var f = e[s];
              if (f) {
                var l = f(u, s, r, o, i + "." + s, a);
                if (l) return l;
              }
            }
            return null;
          }
          return d(t);
        }
        function O(e) {
          function t(t, n, r, o, u) {
            var c = t[n],
              s = x(c);
            if ("object" !== s) return new p("Invalid " + o + " `" + u + "` of type `" + s + "` supplied to `" + r + "`, expected `object`.");
            var f = i({}, t[n], e);
            for (var l in f) {
              var d = e[l];
              if (!d) return new p("Invalid " + o + " `" + u + "` key `" + l + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
              var y = d(c, l, r, o, u + "." + l, a);
              if (y) return y;
            }
            return null;
          }
          return d(t);
        }
        function E(t) {
          switch (typeof t) {
            case "number":
            case "string":
            case "undefined":
              return !0;
            case "boolean":
              return !t;
            case "object":
              if (Array.isArray(t)) return t.every(E);
              if (null === t || e(t)) return !0;
              var n = f(t);
              if (!n) return !1;
              var r,
                o = n.call(t);
              if (n !== t.entries) {
                for (; !(r = o.next()).done;) if (!E(r.value)) return !1;
              } else for (; !(r = o.next()).done;) {
                var i = r.value;
                if (i && !E(i[1])) return !1;
              }
              return !0;
            default:
              return !1;
          }
        }
        function j(e, t) {
          return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
        }
        function x(e) {
          var t = typeof e;
          return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : j(t, e) ? "symbol" : t;
        }
        function S(e) {
          if (void 0 === e || null === e) return "" + e;
          var t = x(e);
          if ("object" === t) {
            if (e instanceof Date) return "date";
            if (e instanceof RegExp) return "regexp";
          }
          return t;
        }
        function T(e) {
          var t = S(e);
          switch (t) {
            case "array":
            case "object":
              return "an " + t;
            case "boolean":
            case "date":
            case "regexp":
              return "a " + t;
            default:
              return t;
          }
        }
        function P(e) {
          return e.constructor && e.constructor.name ? e.constructor.name : k;
        }
        var _ = "function" == typeof Symbol && Symbol.iterator,
          C = "@@iterator",
          k = "<<anonymous>>",
          W = {
            array: y("array"),
            bool: y("boolean"),
            func: y("function"),
            number: y("number"),
            object: y("object"),
            string: y("string"),
            symbol: y("symbol"),
            any: function () {
              return d(r);
            }(),
            arrayOf: m,
            element: function () {
              function t(t, n, r, o, i) {
                var a = t[n];
                if (!e(a)) {
                  return new p("Invalid " + o + " `" + i + "` of type `" + x(a) + "` supplied to `" + r + "`, expected a single ReactElement.");
                }
                return null;
              }
              return d(t);
            }(),
            elementType: function () {
              function e(e, t, n, r, i) {
                var a = e[t];
                if (!o.isValidElementType(a)) {
                  return new p("Invalid " + r + " `" + i + "` of type `" + x(a) + "` supplied to `" + n + "`, expected a single ReactElement type.");
                }
                return null;
              }
              return d(e);
            }(),
            instanceOf: h,
            node: function () {
              function e(e, t, n, r, o) {
                return E(e[t]) ? null : new p("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
              }
              return d(e);
            }(),
            objectOf: b,
            oneOf: v,
            oneOfType: w,
            shape: g,
            exact: O
          };
        return p.prototype = Error.prototype, W.checkPropTypes = u, W.resetWarningCache = u.resetWarningCache, W.PropTypes = W, W;
      };
    }).call(t, n(0));
  }, function (e, t, n) {
    "use strict";

    function r(e) {
      if (null === e || void 0 === e) throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(e);
    } /*
      object-assign
      (c) Sindre Sorhus
      @license MIT
      */
    var o = Object.getOwnPropertySymbols,
      i = Object.prototype.hasOwnProperty,
      a = Object.prototype.propertyIsEnumerable;
    e.exports = function () {
      try {
        if (!Object.assign) return !1;
        var e = new String("abc");
        if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
        for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
        if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
          return t[e];
        }).join("")) return !1;
        var r = {};
        return "abcdefghijklmnopqrst".split("").forEach(function (e) {
          r[e] = e;
        }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
      } catch (e) {
        return !1;
      }
    }() ? Object.assign : function (e, t) {
      for (var n, u, c = r(e), s = 1; s < arguments.length; s++) {
        n = Object(arguments[s]);
        for (var f in n) i.call(n, f) && (c[f] = n[f]);
        if (o) {
          u = o(n);
          for (var l = 0; l < u.length; l++) a.call(n, u[l]) && (c[u[l]] = n[u[l]]);
        }
      }
      return c;
    };
  }, function (e, t, n) {
    "use strict";

    (function (t) {
      function r(e, n, r, c, s) {
        if ("production" !== t.env.NODE_ENV) for (var f in e) if (u(e, f)) {
          var l;
          try {
            if ("function" != typeof e[f]) {
              var p = Error((c || "React class") + ": " + r + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.");
              throw p.name = "Invariant Violation", p;
            }
            l = e[f](n, f, c, r, null, i);
          } catch (e) {
            l = e;
          }
          if (!l || l instanceof Error || o((c || "React class") + ": type specification of " + r + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), l instanceof Error && !(l.message in a)) {
            a[l.message] = !0;
            var d = s ? s() : "";
            o("Failed " + r + " type: " + l.message + (null != d ? d : ""));
          }
        }
      }
      var o = function o() {};
      if ("production" !== t.env.NODE_ENV) {
        var i = n(1),
          a = {},
          u = Function.call.bind(Object.prototype.hasOwnProperty);
        o = function o(e) {
          var t = "Warning: " + e;
          "undefined" != typeof console && console.error(t);
          try {
            throw new Error(t);
          } catch (e) {}
        };
      }
      r.resetWarningCache = function () {
        "production" !== t.env.NODE_ENV && (a = {});
      }, e.exports = r;
    }).call(t, n(0));
  }, function (e, t, n) {
    "use strict";

    function r() {}
    function o() {}
    var i = n(1);
    o.resetWarningCache = r, e.exports = function () {
      function e(e, t, n, r, o, a) {
        if (a !== i) {
          var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw u.name = "Invariant Violation", u;
        }
      }
      function t() {
        return e;
      }
      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: o,
        resetWarningCache: r
      };
      return n.PropTypes = n, n;
    };
  }]);
});